// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gBvhIM2Ygm46m40HC89A {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 0;
}

.a6FHjd20L69FqxYr6cN_ {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/Service/Service.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 16px 0;\n}\n\n.listWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `gBvhIM2Ygm46m40HC89A`,
	"listWrapper": `a6FHjd20L69FqxYr6cN_`
};
export default ___CSS_LOADER_EXPORT___;
